/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { IRemoteDto } from "./i-remote-dto";
import { UserStatusInfoRemoteDto } from "./user-status-info-remote-dto";
import { CallInformationRemoteDto } from "./call-information-remote-dto";
import { DirectoryEntryPresenceRemoteDto } from "./directory-entry-presence-remote-dto";

export class AgentListEntryRemoteDto implements IRemoteDto {
    userId: number;
    userName: string;
    userStatus: UserStatusInfoRemoteDto;
    firstName: string;
    lastName: string;
    displayName: string;
    email: string;
    directoryNumber: string;
    peerNumber: string;
    peerName: string;
    device: string;
    ici: CallInformationRemoteDto;
    memo: string;
    callTime: Date;
    callTimeOffered: Date;
    callState: number;
    memberOfGroups: number[];
    directoryEntryPresence: DirectoryEntryPresenceRemoteDto;
}
